export enum OrderByType {
    Descending = 0,
    Ascending = 1
}